module.exports = require('./environment.json')[process.env.PROD || 'staging'];
